// Huizenga m²-prijscalculator — custom element voor de productpagina.
// Rekent live met exact dezelfde logica als de server-side function
// (window.HZPricing, gegenereerd uit lib/pricing.js).
//
// Meertalig: alle teksten komen uit cfg.i18n (gevuld door het snippet uit de
// theme-locales). De strings hieronder zijn alleen nog terugval.
//
// Cart-properties: de formuliervelden sturen de CANONIEKE waarden in verborgen
// _hz_*-properties (die lezen de functions); dit script vult daarnaast de
// zichtbare, vertaalde properties met het getoonde label.
(function () {
  if (customElements.get('price-calculator')) return;

  // Bedragen volgen de money-format van de shop (NL) zodat de prijs op de
  // productpagina exact hetzelfde oogt als in cart en checkout.
  const EUR = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  });

  class PriceCalculator extends HTMLElement {
    connectedCallback() {
      const cfgEl = this.querySelector('[data-hz-config]');
      if (!cfgEl || !window.HZPricing) return;
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch {
        return;
      }

      this.i18n = this.cfg.i18n || {};
      // Alleen ',' en '.' zijn geldig; alles anders → Nederlands.
      this.decimal = this.i18n.decimal === '.' ? '.' : ',';
      this.m2Format = new Intl.NumberFormat(this.decimal === '.' ? 'en-GB' : 'nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      this.material = this.querySelector('[data-hz-material]');
      this.width = this.querySelector('[data-hz-width]');
      this.height = this.querySelector('[data-hz-height]');
      this.result = this.querySelector('[data-hz-result]');
      this.areaEl = this.querySelector('[data-hz-area]');
      this.priceEl = this.querySelector('[data-hz-price]');
      this.priceOrigEl = this.querySelector('[data-hz-price-orig]');
      this.discountEl = this.querySelector('[data-hz-discount]');
      this.hint = this.querySelector('[data-hz-hint]');
      this.colorsWrap = this.querySelector('[data-hz-colors]');
      this.colorList = this.querySelector('[data-hz-color-list]');
      // Zichtbare, vertaalde properties (naam staat in het snippet).
      this.materialDisplay = this.querySelector('[data-hz-material-display]');
      this.widthDisplay = this.querySelector('[data-hz-width-display]');
      this.colorDisplay = this.querySelector('[data-hz-color-display]');
      this.colorInputs = [];
      this.buildSwatches();

      const t = this.cfg.table;
      this.minCm = this.cfg.minCm || t.defaults.min_cm;
      this.maxCm = this.cfg.maxCm || t.defaults.max_cm;
      this.width.min = this.minCm;
      this.width.max = this.maxCm;
      this.width.step = t.defaults.step_cm || 1;
      this.hint.textContent =
        this.i18n.hint ||
        `Breedte tussen ${this.minCm} en ${this.maxCm} cm; de hoogte volgt uit de verhouding van het kunstwerk.`;

      this.material.addEventListener('change', () => this.update());
      this.width.addEventListener('input', () => this.update());
      this.update();
    }

    /** 103.2 → "103,2" of "103.2", afhankelijk van de taal. */
    fmt(n) {
      return String(n).replace('.', this.decimal);
    }

    submitButtons() {
      const formId = this.dataset.formId;
      const form = document.getElementById(formId);
      if (!form) return [];
      // knoppen ín het formulier + knoppen die er via form="" aan hangen
      return [
        ...form.querySelectorAll('button[name="add"], [type="submit"]'),
        ...document.querySelectorAll(`button[form="${formId}"][name="add"]`),
      ];
    }

    // Radio-swatches (foto + naam) voor de lijstkleur, uit table.frame_colors.
    // Eén keer opgebouwd; tonen/verplichten gebeurt per materiaalkeuze in
    // toggleColors(). Disabled radio's worden niet meegestuurd in het formulier.
    buildSwatches() {
      if (!this.colorList) return;
      const colors = Array.isArray(this.cfg.table.frame_colors)
        ? this.cfg.table.frame_colors.filter((c) => c && c.name)
        : [];
      const formId = this.dataset.formId;
      for (const c of colors) {
        const label = document.createElement('label');
        label.className = 'hz-swatch';
        const input = document.createElement('input');
        input.type = 'radio';
        // value = de tabelnaam; dáár matcht de validation-function op.
        input.name = 'properties[_hz_frame_color]';
        input.value = c.name;
        input.required = true;
        input.disabled = true;
        input.setAttribute('form', formId);
        input.addEventListener('change', () => this.syncColorDisplay());
        label.appendChild(input);
        if (c.image) {
          const img = document.createElement('img');
          img.src = this.sizedImage(c.image, 112);
          img.alt = '';
          img.loading = 'lazy';
          label.appendChild(img);
        }
        const span = document.createElement('span');
        span.textContent = this.colorLabel(c.name);
        label.appendChild(span);
        this.colorList.appendChild(label);
        this.colorInputs.push(input);
      }
    }

    colorLabel(name) {
      return (this.i18n.colors && this.i18n.colors[name]) || name;
    }

    sizedImage(url, px) {
      try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('width', String(px));
        return u.toString();
      } catch {
        return url;
      }
    }

    /** Zichtbare (vertaalde) lijstkleur-property gelijkzetten aan de keuze. */
    syncColorDisplay() {
      if (!this.colorDisplay) return;
      const chosen = this.colorInputs.find((i) => i.checked && !i.disabled);
      this.colorDisplay.value = chosen ? this.colorLabel(chosen.value) : '';
    }

    toggleColors() {
      if (!this.colorsWrap || !this.colorInputs.length) return;
      const mat = window.HZPricing.findMaterial(this.cfg.table, this.material.value);
      const show = !!(mat && mat.framed);
      this.colorsWrap.hidden = !show;
      for (const input of this.colorInputs) {
        input.disabled = !show;
        if (!show) input.checked = false;
      }
      this.syncColorDisplay();
    }

    update() {
      this.toggleColors();
      const res = window.HZPricing.calculatePrice({
        table: this.cfg.table,
        width: this.width.value,
        material: this.material.value,
        ratio: this.cfg.ratio,
        minCm: this.cfg.minCm,
        maxCm: this.cfg.maxCm,
        discountPct: this.cfg.discountPct,
      });

      const buttons = this.submitButtons();

      if (res.ok) {
        this.height.value = this.fmt(res.heightCm);
        const opt = this.material.selectedOptions[0];
        if (this.materialDisplay) this.materialDisplay.value = opt ? opt.textContent.trim() : '';
        if (this.widthDisplay) this.widthDisplay.value = this.fmt(res.widthCm);
        this.areaEl.textContent = `${this.fmt(res.widthCm)} × ${this.fmt(res.heightCm)} cm · ${this.m2Format.format(res.m2)} m² · `;
        this.priceEl.textContent = EUR.format(res.price);
        if (this.priceOrigEl && this.discountEl) {
          if (res.discountPct > 0) {
            this.priceOrigEl.textContent = EUR.format(res.priceOriginal);
            this.priceOrigEl.hidden = false;
            this.discountEl.textContent = `-${res.discountPct}%`;
            this.discountEl.hidden = false;
          } else {
            this.priceOrigEl.hidden = true;
            this.discountEl.hidden = true;
          }
        }
        this.result.hidden = false;
        this.setCustomError('');
        buttons.forEach((b) => (b.disabled = false));
      } else {
        this.height.value = '';
        // Nooit een oude zichtbare waarde laten staan bij ongeldige invoer.
        if (this.materialDisplay) this.materialDisplay.value = '';
        if (this.widthDisplay) this.widthDisplay.value = '';
        this.result.hidden = true;
        buttons.forEach((b) => (b.disabled = true));
        if (res.error === 'width_out_of_range' && this.width.value) {
          this.setCustomError(
            this.i18n.widthError || `Kies een breedte tussen ${this.minCm} en ${this.maxCm} cm.`,
          );
        } else {
          this.setCustomError('');
        }
      }
    }

    setCustomError(msg) {
      this.width.setCustomValidity(msg);
      if (msg) this.width.reportValidity();
    }
  }

  customElements.define('price-calculator', PriceCalculator);
})();
